// extracted by mini-css-extract-plugin
module.exports = {"ActionBar":"OnboardingRequests_ActionBar__1795O","AggregatorSearch":"OnboardingRequests_AggregatorSearch__24KwF"};